import { AdminProvider } from "@/contexts/AdminProvider";
import { Routes } from "react-router-dom";
import { renderRouteTree } from "./routeTree";

export interface AdminRoutesProps {
  readonly isAdminDomain: boolean;
}

export function AdminRoutes({ isAdminDomain }: AdminRoutesProps) {
  return (
    <AdminProvider>
      <Routes>{renderRouteTree({ isAdminDomain })}</Routes>
    </AdminProvider>
  );
}

// Default export for lazy loading (Phase 5.1: Code Splitting)
export default AdminRoutes;